/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
// import { useBlockProps } from '@wordpress/block-editor';
import { useBlockProps,
	AlignmentControl,
	RichText,
	InspectorControls,
	PanelColorSettings,
	MediaUpload,
    InnerBlocks
	} from '@wordpress/block-editor';
import { useMemo , Fragment} from '@wordpress/element';

import ColorPopup from '../Components/ColorPopup';

import {
	PanelBody ,
	PanelRow,
	TextControl,
	__experimentalNumberControl as NumberControl,
	__experimentalBorderBoxControl as BorderBoxControl,
	__experimentalBoxControl,
	RangeControl,
	ToggleControl,
	ColorPalette,
	SelectControl,
	Card,
	CardBody,
	CardHeader,
	TabPanel,
	Flex, FlexBlock, FlexItem,
    ColorPicker,
	} from '@wordpress/components';


import { GLOBAL_FONTS } from '../Global/GLOBAL_FONTS';
import { GLOBAL_FONTS_WEIGHTS } from '../Global/Global_font_weights';
import { GLOBAL_ICONS } from '../Global/Global_Icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignCenter, faAlignLeft, faAlignRight, faHeading, faStar, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';


/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function edit({attributes, setAttributes}) {

    const {
        type,
        popupDelay,
        buttonColor,
        buttonText,
        buttonTextSize,
        buttonWidth,
        buttonHeight,
        closeButtonPosition,
        textColor,
        textFontFamily

    } = attributes;
  
    function myFunction(value) {
        var oferts = document.querySelectorAll(".k2-modal-inspector-popuptext .components-color-picker__inputs-wrapper");
        for (var i=0; i<oferts.length; i++){
            oferts[i].style.display = 'none';
        }
        var ParentDiv = value.target.parentNode
        var PopupDiv = ParentDiv.getElementsByTagName('span')
        if (PopupDiv[1].hidden  === true){
            PopupDiv[1].hidden  = false
        } else if (PopupDiv[1].hidden  === false){
            PopupDiv[1].hidden  = true
        }
    }

    function onCloseButtonPositionChange(value){
        if(value=='topright'){
            setAttributes({
                closeButtonPosition:{top:0,right:0,text:value}
            })
        }
        else if(value == 'topleft'){
            setAttributes({
                closeButtonPosition:{top:0,right:'auto',text:value}
            })
        }
        else if(value == 'bottomright'){
            setAttributes({
                closeButtonPosition:{top:'90%',right:0,text:value}
            })
        }
        else if(value == 'bottomleft'){
            setAttributes({
                closeButtonPosition:{top:'90%',right:'auto',text:value}
            })
        }
        console.log(closeButtonPosition)
    }
    var controls = (
        <PanelBody title={"Button styling"}>
            <TextControl
                label={<strong>Text</strong>}
                onChange={(value)=>{setAttributes({buttonText:value})}}
                value = {buttonText}
            />

            <PanelRow>
                <p><strong>Title color</strong></p>
                <div className="k2-modal-inspector-popup">
                        <span style={{backgroundColor:textColor }} className={ 'k2-modal-inspector-dot' } onClick={ myFunction }>
                            </span>
                    <span className="k2-modal-inspector-popuptext" id="myPopup" hidden={ true }>

                            <div>
                                <ColorPicker
                                    color={ textColor }
                                    onChangeComplete={ ( value ) => {setAttributes( {textColor:'rgba('+value.rgb.r+','+value.rgb.g+','+value.rgb.b+','+value.rgb.a+')'} ); console.log(haloColor)} }
                                />
                                <TextControl
                                    onChange={ ( value ) => {
                                        setAttributes( { textColor: value } )
                                    } }
                                    value={ textColor }
                                />
                            </div>

                        </span>
                </div>
            </PanelRow>



            <SelectControl
                        label="Text Font"
                        value={textFontFamily}
                        options={GLOBAL_FONTS}
                        onChange={(value)=>{setAttributes({textFontFamily:value})}}
            />

            <PanelRow>
                <p><strong>Button color</strong></p>
                <div className="k2-modal-inspector-popup">
                        <span style={{backgroundColor:buttonColor }} className={ 'k2-modal-inspector-dot' } onClick={ myFunction }>
                            </span>
                    <span className="k2-modal-inspector-popuptext" id="myPopup" hidden={ true }>

                            <div>
                                <ColorPicker
                                    color={buttonColor}
                                    onChangeComplete={(value)=>{setAttributes({buttonColor:'rgba('+value.rgb.r+','+value.rgb.g+','+value.rgb.b+','+value.rgb.a+')'})}}
                                />
                                <TextControl
                                    onChange={ ( value ) => {
                                        setAttributes( { buttonColor: value } )
                                    } }
                                    value={ buttonColor }
                                />
                            </div>

                        </span>
                </div>
            </PanelRow>


            <RangeControl
                label= "Button width"
                value={ buttonWidth }
                onChange={ (value)=>{setAttributes({buttonWidth:value})} }
                min={ 0.1 }
                max={ 10 }
                step ={0.1}
            />
            <RangeControl
                label= "Button Height"
                value={ buttonHeight }
                onChange={ (value)=>{setAttributes({buttonHeight:value})} }
                min={ 0.1 }
                max={ 10 }
                step ={0.1}
            />
            <RangeControl
                label= "Font size"
                value={ buttonTextSize }
                onChange={ (value)=>{setAttributes({buttonTextSize:value})} }
                min={ 0.1 }
                max={ 10 }
                step ={0.1}
            />
        </PanelBody>
    );
    if(type == 'time'){

        controls = (
                        <PanelBody>

                                <RangeControl
                                            label= "Popup delay (secs)"
                                            value={ popupDelay }
                                            onChange={ (value)=>{setAttributes({popupDelay:value})} }
                                            min={ 1 }
                                            max={ 10 }
                                            step ={1}
                                        />
                        </PanelBody>

        );
    }

    var buttonStyle = {
        backgroundColor: buttonColor,
        padding : buttonHeight+"em "+buttonWidth+"em",
        fontSize: buttonTextSize+"em",
        fontFamily:textFontFamily,
        color: textColor,

    }
    var closeButtonStyle = {
        top:closeButtonPosition.top,
        right:closeButtonPosition.right
    }
    return ([
        <InspectorControls>
            <PanelBody>

                <SelectControl
                    label="Type"
                    value={type}
                    options={[
                        { label: 'Button', value: 'button' },
                        { label: 'Timed', value: 'time'}
                    ]}
                    onChange={(value)=>{setAttributes({type:value})}}
                />
                <SelectControl
                    label="'Close' button position"
                    value={closeButtonPosition.text}
                    options={[
                        { label: 'Top Right', value: 'topright' },
                        { label: 'Top Left', value: 'topleft'}
                    ]}
                    onChange={onCloseButtonPositionChange}
                />

            </PanelBody>

            {controls}
        </InspectorControls>

        ,
        <div className={'k2-modal-container'}>
            {(type == 'button') &&
                <button className={'k2-modal-button'} style = {buttonStyle}>{buttonText}</button>
            }
            <div className="k2-modal-backend">
                <div className="k2-modal-content-backend">
                    <InnerBlocks renderAppender={ () => (<InnerBlocks.ButtonBlockAppender/>) }/>
                </div>
                <div className="k2-modal-close" style={closeButtonStyle}>&times;</div>
            </div>
        </div>
    ])
}
